// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetLatestStatsResult = objectOf({
  total_count: number,
  date: number,
  customer_groups: arrayOf(
    objectOf({
      name: string,
      display_name: string,
      description: string,
      count: number,
      pct: number,
    })
  ),
});
